export default "__VITE_ASSET__809b6e5b__"